import { render, staticRenderFns } from "./CustomCloseButton.vue?vue&type=template&id=e11771f0&scoped=true"
import script from "./CustomCloseButton.vue?vue&type=script&lang=js"
export * from "./CustomCloseButton.vue?vue&type=script&lang=js"
import style0 from "./CustomCloseButton.vue?vue&type=style&index=0&id=e11771f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e11771f0",
  null
  
)

export default component.exports